// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const NotificationIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="NotificationIcon" ref={forwardedRef} {...props}>
      <path d="M14.49 8.486a4.5 4.5 0 0 0-3.494-4.374V2.5H9v1.61a4.5 4.5 0 0 0-3.503 4.387v3.999l-1.494.501H4V14.5h12v-1.501l-1.5-.502zM7 11.498H6.997V8.497a2.997 2.997 0 0 1 5.993-.008l.007 2.95H13v1.56H7z" />
      <path d="M9 16v2h1.996v-2z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const NotificationIcon = /* @__PURE__ */ Object.assign(
  NotificationIconComponent,
  { displayName: 'NotificationIcon' },
);
